import { connect } from 'react-redux';
import { useField } from 'react-final-form';
import { v4 as uuidv4 } from 'uuid';

import { Button } from '../../../UIPackage/MainModule/components/Button';
import { ErknmApproveRemarkSectionCodeEnum } from '../enums/ErknmApproveRemarkSectionCodeEnum';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import {
  getKnmFormRef,
  getKnmIsErknmStatusApproving,
  getKnmIsErknmStatusCommentsExist,
  getKnmWatchOnlyByTestUser,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { IKnmErknmFormApproveRemark } from '../../MainModule/interfaces/IKnmErknmFormApproveRemark';
import { getUserRoleIsProsecutor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { KnmTypeCodesEnum } from '../../../APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { ApprovedTypesEnum } from '../../../APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { ErknmPlanStatusesEnum } from '../../../APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { getIsPlanErknmStatusUnderConsideration } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';

interface IErknmApproveRemarkAddButtonProps {
  sectionCode: ErknmApproveRemarkSectionCodeEnum;
}

interface IErknmApproveRemarkAddButtonStoreProps {
  formRef: IKnmFormRef | undefined;
  isKnmStatusApproving: boolean;
  isKnmStatusCommentsExist: boolean;
  isProsecutor: boolean;
  isWatchOnlyByTestUser: boolean;
  knmPlanStatus: ErknmPlanStatusesEnum | undefined;
}

const ErknmApproveRemarkAddButtonWithoutStore = ({
  sectionCode,
  formRef,
  isKnmStatusApproving,
  isKnmStatusCommentsExist,
  isProsecutor,
  isWatchOnlyByTestUser,
  knmPlanStatus,
}: IErknmApproveRemarkAddButtonProps & IErknmApproveRemarkAddButtonStoreProps) => {
  const approveRemarksFieldName = 'approveRemarks' as keyof IKnmForm;
  const typeErknm: IKnmForm['typeErknm'] = useField('typeErknm' as keyof IKnmForm, { subscription: { value: true } })
    .input.value;
  const approved: IKnmForm['approved'] = useField('approved' as keyof IKnmForm, { subscription: { value: true } }).input
    .value;
  const approveRemarks: IKnmForm['approveRemarks'] = useField(approveRemarksFieldName, {
    subscription: { value: true },
  }).input.value;

  const isOnApproval = approved?.value === ApprovedTypesEnum.ON_APPROVAL;
  const isApprovedWithRemark = approved?.value === ApprovedTypesEnum.APPROVED_WITH_REMARK;

  const isShowButton =
    !isWatchOnlyByTestUser &&
    isProsecutor &&
    typeErknm?.code === KnmTypeCodesEnum.PP &&
    getIsPlanErknmStatusUnderConsideration(knmPlanStatus) &&
    ((isKnmStatusApproving && (isOnApproval || isApprovedWithRemark)) ||
      (isKnmStatusCommentsExist && isApprovedWithRemark));

  if (!isShowButton) {
    return null;
  }

  const push = formRef?.current.mutators.push;

  const isApproveRemarkExist =
    Array.isArray(approveRemarks) && approveRemarks?.some(item => item.sectionCode === sectionCode);

  const addHandle = () => {
    if (push && !isApproveRemarkExist) {
      const remark: IKnmErknmFormApproveRemark = {
        listId: uuidv4(),
        sectionCode,
      };

      push(approveRemarksFieldName, remark);
    }
  };

  return (
    <Button
      text="Замечание"
      className="shared-btn-add"
      type="button"
      variant="link"
      color="primary"
      onClick={addHandle}
      disabled={isApproveRemarkExist}
    />
  );
};

const mapStateToProps = (state: IRootState): IErknmApproveRemarkAddButtonStoreProps => ({
  formRef: getKnmFormRef(state),
  isProsecutor: getUserRoleIsProsecutor(state),
  isKnmStatusCommentsExist: getKnmIsErknmStatusCommentsExist(state),
  isKnmStatusApproving: getKnmIsErknmStatusApproving(state),
  knmPlanStatus: getPlanListPlanErknmStatus(state),
  isWatchOnlyByTestUser: getKnmWatchOnlyByTestUser(state),
});

export const ErknmApproveRemarkAddButton = connect(mapStateToProps)(ErknmApproveRemarkAddButtonWithoutStore);
